export const colours = {
  white: '#ffffff',
  black: '#000000',
  lightGrey: '#e3e3e3',
  mediumGrey: '#afafaf',
  grey: '#444444',
  aquamarine: 'aquamarine',
}